import React from "react";
import { useHistory } from "react-router-dom";
import { Box, Divider, Paper, Button } from "@material-ui/core";
import { ButtonLoader, IntroText, Sheet, SheetContent } from "../../components";
import { CONSUMER_SESSION_APPOINTMENT } from "../../constants";
import { useTranslation } from "react-i18next";

const AppointmentPending = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleError = () => {
    return history.push(`/`);
  };

  const handlePay = () => {
    const appointmentSession = sessionStorage.getItem(
      CONSUMER_SESSION_APPOINTMENT
    );

    if (!appointmentSession) handleError();

    try {
      const appointment = JSON.parse(appointmentSession);
      const { payment_url, total_cost, total_balance } = appointment;

      if (!payment_url || !total_balance) handleError();

      history.push({
        pathname: `/appointment/pay`,
        state: {
          paymentUrl: payment_url,
          totalCost: total_cost || total_balance,
          totalBalance: total_balance
        }
      });
    } catch (error) {
      handleError();
    }
  };

  const handleNewAppointment = () => {
    sessionStorage.removeItem(CONSUMER_SESSION_APPOINTMENT);

    return history.push(`/`);
  };

  return (
    <Sheet data-cy="appointment-pending-view">
      <SheetContent>
        <Box mb={2}>
          <Paper>
            <Box p={2}>
              <IntroText>{t("appointment.pending.intro_text")}</IntroText>
              <ButtonLoader
                variant="contained"
                color="primary"
                fullWidth
                size="large"
                data-cy="button-pending-pay"
                onClick={e => handlePay()}
              >
                {t("appointment.pending.button_pay_now")}
              </ButtonLoader>
              <Box my={2}>
                <Divider variant="middle" />
              </Box>
              <Button
                variant="contained"
                color="default"
                fullWidth
                size="large"
                data-cy="button-pending-new"
                onClick={e => handleNewAppointment()}
              >
                {t("appointment.pending.button_new_appointment")}
              </Button>
            </Box>
          </Paper>
        </Box>
      </SheetContent>
    </Sheet>
  );
};

export { AppointmentPending };
